import React from 'react';
import { t, getContactNumber, getCurrentLocale,getCreateAccountURL,getLoginURL } from '@insight/toolkit-utils';
import { INSIGHT_CURRENT_LOCALE_COOKIE_NAME, ADD_TO_CART_CATEGORY_TYPES } from '../../constants';
import { CalloutBox } from '@insight/toolkit-react';

function CalloutActions({ isCallForPrice, isLoggedOutIPS, categoryType = ADD_TO_CART_CATEGORY_TYPES.MAIN_SEARCH_RESULTS }) {
  const locale = getCurrentLocale(INSIGHT_CURRENT_LOCALE_COOKIE_NAME) || 'en_US'; // Default locale if null or undefined

  const contactNumber = getContactNumber(locale) || '';
  const callForPriceLabelText = t('Contact us for pricing & availability');
  const callForPriceLabelNumber = `${t('Call')} ${contactNumber} ${t('for Price')}`;
  return (
    <CalloutBox
      isCallForPrice={isCallForPrice}
      callForPriceLabel={callForPriceLabelText}
      callForPriceLabelNumber={callForPriceLabelNumber}
      contactNumberValue={contactNumber}
      loginLink={getLoginURL()}
      accountLink={getCreateAccountURL()}
      isLoggedOutIPS={isLoggedOutIPS}
      categoryType={categoryType}
    />
  );
}

export default CalloutActions;